// Read CSS variable from :root, with optional fallback.
// Junior-friendly, no dependencies.
export function cssVar(name, fallback = '') {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name);
    const val = v && v.trim();
    return val || fallback;
  } catch (e) {
    return fallback;
  }
}
